import React, { useContext } from 'react';
import { ModificationDate, Toolbar } from '@europrocurement/flexy-components';
import { Box } from '@mui/material';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import DossierRoutingContext from '../../../providers/DossierRoutingContext';
import DetailDossierActionMenu from '../DetailDossierActionMenu/DetailDossierActionMenu';

export type DetailDossierToolbarProps = {
    dossier: DossierOpenSearch;
    source: 'FRONT' | 'BACK';
    siblingDossiers?: DossierOpenSearch[];
    /** Logique pour déterminer si c'est multi-dossiers */
    isMultiDossiers?: boolean;
};

const DetailDossierToolbar: React.FunctionComponent<DetailDossierToolbarProps> = function (props) {
    const { dossier, source = 'FRONT', siblingDossiers = [], isMultiDossiers = false } = props;

    const { getOrderRoute, getDossierRoute, getDossiersListeRoute } =
        useContext(DossierRoutingContext);

    // Construction du breadcrumb path
    const breadcrumbPath = [
        {
            link: getOrderRoute(dossier.collectionId as number),
            path: `Commande #${dossier.collectionNumero as string}`,
        },
        // Dossier avec ou sans dropdown selon le contexte
        isMultiDossiers
            ? {
                  path: `Dossier #${dossier.numero as string}`,
                  link: getDossierRoute(dossier.id as number),
                  dropdown: {
                      title: `Dossier #${dossier.numero as string}`,
                      siblingDossiers,
                      currentDossierId: dossier.id as number,
                      getDossierRoute,
                  },
              }
            : {
                  link: getDossierRoute(dossier.id as number),
                  path: `Dossier #${dossier.numero as string}`,
              },
        '',
    ];

    return (
        <Toolbar
            path={breadcrumbPath}
            previousPath={getDossiersListeRoute()}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <ModificationDate
                    date={new Date(dossier.dateCreation as string)}
                    displayIcon={false}
                    isCreationDate
                    sxProps={{ opacity: 0.5, whiteSpace: 'nowrap' }}
                />
                <DetailDossierActionMenu
                    dossier={dossier}
                    source={source}
                />
            </Box>
        </Toolbar>
    );
};

export default DetailDossierToolbar;
